module.exports = __webpack_public_path__ + "static/img/img_2288.9a70ffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_2288.jpg
// module id = wF/8
// module chunks = 0